;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputNumberButtonsController', InputNumberButtonsController)

  /* @ngInject */
  function InputNumberButtonsController ($scope) {
    $scope.onChange = function (newValue) {
      if (newValue < $scope.minValue || ($scope.maxValue && newValue > $scope.maxValue)) {
        $scope.model = ''
      } else if ($scope.change) {
        $scope.change({
          modelPropertyName: $scope.modelPropertyName,
          modelNewValue: newValue
        })
      }
    }

    $scope.subtractOfNumberField = function () {
      $scope.model = ($scope.model || $scope.minValue) - 1
    }

    $scope.sumToNumberField = function () {
      $scope.model = ($scope.model || $scope.minValue) + 1
    }
  }
})()
